import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RecommendationProductBlockVisible } from '../../../../services/dispatchers';
import { selectRecommendationProductsAnalitics } from '../../../../store/recommendationProducts';
import { RecommendationProductsStore } from '../../../../store/recommendationProducts/types';

export const useObservable = () => {
  const childRef = useRef<HTMLDivElement>(null);
  const productsAnalitics = useSelector(
    (state: RecommendationProductsStore) =>
      selectRecommendationProductsAnalitics(state)
  );

  useEffect(() => {
    const child = childRef.current as HTMLDivElement;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          RecommendationProductBlockVisible.dispatch({
            products: productsAnalitics
          });
          observer.unobserve(child);
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 1
      }
    );

    if (child && productsAnalitics) observer.observe(child);

    return () => child && observer.unobserve(child);
  }, [productsAnalitics, childRef]);

  return {
    childRef
  };
};
